import React from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { Col } from "react-bootstrap";
import {
  AutoCompleteField,
  FormRow,
  Check
} from "MODULES/shared/components/Forms";
import {
  EXPECTED_COMPONENT,
  MOD_TO_ID,
  SHOP_ASSIST,
  TEARDOWN
} from "MODULES/RepairOrders/constants";
import { PART_ID } from "MODULES/inventories/constants";
import InventoryTable from "./InventoryTable";

export default class PartDetailsSection extends React.Component {
  state = {
    selectedPart: {},
    selectedModTo: {},
    inventory: []
  };

  componentWillMount() {
    if (this.props.part) {
      this.handlePartSelected(this.props.part);
    }

    if (this.props.modTo) {
      this.handleModToSelected(this.props.modTo);
    }
  }

  handlePartSelected = part => {
    if (part && part.id && this.props.requestedAction !== EXPECTED_COMPONENT) {
      this.props
        .searchInventories(part.id, {
          repair_status: "reserve_for_repair,reserve_for_shop_assist",
          sort: "id"
        })
        .then(results => {
          this.setState({ inventory: results });
        });
    }
    this.setState({ selectedPart: part });
  };

  handleModToSelected = part => this.setState({ selectedModTo: part });

  render() {
    const {
      queryParts,
      queryPartsByStatus,
      getField,
      setField,
      notifyForm,
      editing,
      disabled,
      requestedAction
    } = this.props;
    const { selectedPart, selectedModTo, inventory } = this.state;
    const searchParts =
      requestedAction === EXPECTED_COMPONENT ? queryParts : queryPartsByStatus;

    return [
      <div className="nav nav-tabs" key="part_form_header">
        <h4>Part Details</h4>
      </div>,
      <div
        className="row row-col-gutters-half"
        style={{ marginTop: 10 }}
        key="part_form_1"
      >
        {!editing && (
          <Col md={6}>
            <Field
              name={PART_ID}
              label="Part #"
              placeholder="Type a part's number..."
              component={AutoCompleteField}
              search={searchParts}
              selectedItem={selectedPart}
              disabled={disabled}
              formatItem={result => result && result.part_number}
              onItemSelected={i => i && this.handlePartSelected(i)}
              required
            />
          </Col>
        )}
        {![SHOP_ASSIST, EXPECTED_COMPONENT, TEARDOWN].includes(
          requestedAction
        ) && (
          <Col md={6}>
            <Field
              name={MOD_TO_ID}
              label="Mod To"
              addon={<i className="fa fa-exchange" />}
              placeholder="Type a part's number..."
              component={AutoCompleteField}
              search={queryParts}
              selectedItem={selectedModTo}
              formatItem={result => result && result.part_number}
              onItemSelected={i => i && this.handleModToSelected(i)}
              disabled={disabled}
            />
          </Col>
        )}
        <Col md={6}>
          <div className="form-group">
            <div
              className="btn-group btn-group-justified btn-group-vertical"
              data-toggle="buttons"
            >
              <label className="control-label" htmlFor="for_second_opinion">
                Second Opinion
              </label>
              <div>
                <Field
                  name="for_second_opinion"
                  label="Sending for Second Opinion"
                  component={Check}
                  icon="fa-check-circle"
                  disabled={disabled}
                />
              </div>
            </div>
          </div>
        </Col>
      </div>,
      <FormRow key="part_results">
        {inventory.length > 0 &&
          !editing && (
            <InventoryTable
              results={inventory}
              getField={getField}
              setField={setField}
              notifyForm={notifyForm}
            />
          )}
      </FormRow>
    ];
  }
}

PartDetailsSection.propTypes = {
  requestedAction: PropTypes.string,
  queryParts: PropTypes.func.isRequired,
  queryPartsByStatus: PropTypes.func.isRequired,
  notifyForm: PropTypes.func.isRequired,
  getField: PropTypes.func.isRequired,
  setField: PropTypes.func.isRequired,
  searchInventories: PropTypes.func.isRequired,
  editing: PropTypes.bool,
  disabled: PropTypes.bool,
  modTo: PropTypes.shape({}),
  part: PropTypes.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/FormSections/PartDetailsSection/PartDetailsSection.jsx